import { useContext, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import NoteCard from "../../components/note-card.jsx";
import UserContext from "../../context/user";
import LanguageContext from "../../context/language.jsx";
import useHomeData from "./use-home-data";
import placeholders from "../../utils/placeholders.js";
import LoadingError from "../loading-error.jsx";

const SectionNotes = ({ data, sectionId, onLoad, organizationalNotesLink }) => {
  const { isPreview, callApi } = useContext(UserContext);
  const { labels } = useContext(LanguageContext);
  const [error, setError] = useState();

  const loadNotes = useCallback(
    async (cmsLang) => {
      if (cmsLang && isPreview && sectionId) {
        const result = await callApi(`/resource/notes/${sectionId}/preview`, { skipPreview: true });
        return { notes: result?.data, notesKey: cmsLang + isPreview };
      }
      const params = new URLSearchParams(Object.entries({ pageNumber: 0, pageSize: 4 }));
      const data = await callApi(`/resource/notes?${params.toString(params)}&locale=${cmsLang}`, {
        method: "POST",
        skipPreview: true,
      });
      return { notes: data?.data, notesKey: cmsLang + isPreview };
    },
    [callApi, isPreview, sectionId]
  );
  useHomeData(data.notesKey, onLoad, loadNotes, setError);
  const notes = data.notes || placeholders(1);

  return error ? (
    <LoadingError />
  ) : (
    <div className="home__section">
      <div className="home__notes ">
        {notes?.map((item, i) => (
          <NoteCard
            note={item}
            key={item.id || i}
            tealiumId={`home_globalUpdates_${item.masterID}_organizationalNotes`}
          />
        ))}
      </div>
      <div className="text-center">
        <Link to={organizationalNotesLink} className="button secondary">
          {labels?.SEE_ALL}
        </Link>
      </div>
    </div>
  );
};

export default SectionNotes;
